import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  TextareaAutosize,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageAttachment from "components/image-cropper/ImageAttachment";
const DEFAULT_IMAGE_URL =
  "https://assets.promptbase.com/DALLE_IMAGES%2F0wbTCfH5rym9qX6gukTX%2Fresized%2F1690684977463_800x800.webp?alt=media&token=c39b1396-3bb9-493f-8829-e963804d6b52";

const categories = [
  { label: "Քաղաքական", value: "politic" },
  { label: "Սոցիալական", value: "social" },
  { label: "Տնտեսական", value: "economic" },
  { label: "Մարգարեական", value: "prophetic" },
  { label: "Ֆինանսական", value: "finance" },
  { label: "Սպորտային", value: "sport" },
  { label: "Գիտական", value: "scientific" },
];

const PredictionOverview = ({
  overview,
  errors,
  setFieldValue,
  deletePrediction,
  id,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-8 items-center w-full px-20 overflow-auto max-h-screen">
      <div className="w-3/4 flex flex-col gap-2">
        <div>
          <Checkbox
            checked={overview?.published}
            color="primary"
            onChange={(e) => {
              setFieldValue("published", !overview?.published);
            }}
            value="Հրապարակել"
          />
          <span>Հրապարակված է</span>
        </div>
        <TextField
          size="small"
          value={overview?.title || ""}
          onChange={(e) => setFieldValue("title", e.target.value)}
          fullWidth
          label={t("predictions.title")}
          error={Boolean(errors?.title)}
          helperText={t(errors?.title)}
        />
        <TextareaAutosize
          minRows={3}
          maxRows={8}
          className="w-full border-2 border-gray-300 rounded-md p-2"
          defaultValue={overview?.description || ""}
          onChange={(e) => setFieldValue("description", e.target.value)}
          placeholder={t("predictions.desc")}
          error={Boolean(errors?.description)}
          helperText={t(errors?.description)}
        />
        <div className="grid grid-cols-3 p-1 my-2 border rounded-lg shadow-md">
          {categories.map((category) => {
            return (
              <FormControlLabel
                key={category.value}
                control={
                  <Checkbox
                    checked={overview?.categories?.includes(category.value)}
                    color="primary"
                    onChange={(e) =>
                      setFieldValue(
                        "categories",
                        overview?.categories?.includes(e.target.value)
                          ? overview?.categories?.filter(
                              (cat) => cat !== e.target.value,
                            )
                          : [...(overview?.categories || []), e.target.value],
                      )
                    }
                    value={category.value}
                  />
                }
                label={category.label}
              />
            );
          })}
        </div>
        <div className="p-1 my-2 border rounded-lg shadow-md">
          <FormControl fullWidth variant="outlined" className="p-4">
            <InputLabel>Բարդություն</InputLabel>
            <Select
              value={overview?.level || ""}
              onChange={(e) => {
                if (setFieldValue) setFieldValue("level", e.target.value);
              }}
              label="level"
            >
              {[1, 2, 3, 4, 5].map((level) => (
                <MenuItem key={level} value={level}>
                  {level}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="grid my-2 grid-cols-2 gap-4">
          <TextField
            label="Քվյարկության ավարտ"
            type="datetime-local"
            value={overview?.endOfVoting || ""}
            onChange={(e) => setFieldValue("endOfVoting", e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            label="Վերջնաժամկետ"
            type="datetime-local"
            value={overview?.deadline || ""}
            onChange={(e) => setFieldValue("deadline", e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </div>
        <div className="flex justify-center">
          <ImageAttachment
            crop
            aspect={1}
            containerClassName="relative w-full"
            onSave={(file, url) => setFieldValue("image", file)}
            imageClassName="object-cover w-[200px] h-[200px]"
            image={overview?.image}
            removeImage={() => setFieldValue("image", "")}
            defaultUrl={DEFAULT_IMAGE_URL}
          />
        </div>
      </div>
      {id && (
        <Button
          color="error"
          variant="contained"
          className="mb-24"
          onClick={() => {
            setOpen(true);
          }}
        >
          Ջնջել կանխատեսումը
        </Button>
      )}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle> Հաստատում </DialogTitle>
        <DialogContent dividers>
          Դուք համոզված ե՞ք, որ կանխատեսումը պետք է ջնջվի։
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)}>
            Չեղարկել
          </Button>
          <Button
            onClick={() => {
              deletePrediction();
              setOpen(true);
              navigate("/predictions");
            }}
          >
            Ջնջել
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PredictionOverview;
